import React from 'react'


class CheckboxSubject extends React.Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
      }

    onChange(e){
       this.props.onChange(e);
    }

    render() {
        return (
            <li>
                <input id={this.props.id} name={this.props.name} key={this.props.id} onChange={this.onChange} type="checkbox" checked={this.props.isChecked} value={this.props.value} />
                <label className="form-check-label checkbox-label" htmlFor={this.props.id}> {this.props.id} <span className="d-xs-inline d-sm-inline d-md-inline d-lg-none d-xl-inline">{this.props.value}</span></label>
            </li>
        );
    }
}

export default CheckboxSubject
